<template>
  <!-- Service Section -->
  <section class="service-section service-sec-two">
    <div class="container">
      <div class="section-heading">
        <div class="row align-items-center">
          <div class="col-md-6 aos" data-aos="fade-up">
            <h2>Featured Services</h2>
            <p>A featured services marketplace typically offers a platform where various service
              providers can showcase their services to potential customers.</p>
          </div>
          <div class="col-md-6 text-md-end aos" data-aos="fade-up">
            <div class="owl-nav mynav"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel service-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexfeaturedservice" :key="item.id">
                <div class="service-widget aos" data-aos="fade-up">
                  <div class="service-img">
                    <router-link to="/details/service-details">
                      <img class="img-fluid serv-img" alt="Service Image"
                        :src="require(`@/assets/img/providers/${item.Image}`)">
                    </router-link>
                    <div class="fav-item">
                      <router-link to="/service-categories/categories"><span class="item-cat">Cleaning</span></router-link>
                      <a href="javascript:void(0)" class="fav-icon" @click="toggleSelected">
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                    <div class="item-info">
                      <router-link to="/service-provider/providers"><span class="item-img"><img
                        :src="require(`@/assets/img/profiles/${item.Avatar}`)" class="avatar"
                        alt="User"></span></router-link>
                    </div>
                  </div>
                  <div class="service-content text-start">
                    <h3 class="title">
                      <router-link to="/details/service-details">{{ item.Content }}</router-link>
                    </h3>
                    <p><i class="feather-map-pin me-1"></i>{{ item.Country }}<span class="rate"><i
                          class="fas fa-star filled me-1"></i>4.9</span></p>
                    <div class="serv-info">
                      <h6>{{item.Price}}</h6>
                      <router-link to="/details/service-details" class="btn btn-light">Book Now</router-link>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
        <div class="btn-sec d-flex justify-content-center aos" data-aos="fade-up">
          <router-link to="/service/search"
            class="btn btn-dark  d-flex align-items-center justify-content-center">View All<i
              class="ti ti-arrow-right ms-1"></i></router-link>
        </div>
      </div>
    </div>
  </section>
  <!-- /Service Section -->

  <!-- Providers Section -->
  <section class="providers-section">
    <div class="container">
      <div class="section-heading">
        <div class="row">
          <div class="col-md-6 aos" data-aos="fade-up">
            <h2>Top Providers</h2>
            <p>Meet Our Experts</p>
          </div>
          <div class="col-md-6 text-md-end aos" data-aos="fade-up">
            <router-link to="/service-provider/providers" class="btn btn-primary btn-view"
              >View All<i class="feather-arrow-right-circle"></i
            ></router-link>
          </div>
        </div>
      </div>
      <div class="row aos" data-aos="fade-up">
        <div class="col-lg-3 col-sm-6">
          <div class="providerset">
            <div class="providerset-img">
              <router-link to="/service-provider/provider-details">
                <img src="@/assets/img/provider/provider-11.jpg" alt="img" />
              </router-link>
            </div>
            <div class="providerset-content">
              <div class="providerset-price">
                <div class="providerset-name">
                  <h4>
                    <router-link to="/service-provider/provider-details">John Smith</router-link
                    ><i class="fa fa-check-circle" aria-hidden="true"></i>
                  </h4>
                  <span>Electrician</span>
                </div>
                <div class="providerset-prices">
                  <h6>$20.00<span>/hr</span></h6>
                </div>
              </div>
              <div class="provider-rating">
                <div class="rating">
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star-half-stroke filled"></i><span>(320)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="providerset">
            <div class="providerset-img">
              <router-link to="/service-provider/provider-details">
                <img src="@/assets/img/provider/provider-12.jpg" alt="img" />
              </router-link>
            </div>
            <div class="providerset-content">
              <div class="providerset-price">
                <div class="providerset-name">
                  <h4>
                    <router-link to="/service-provider/provider-details">Michael</router-link
                    ><i class="fa fa-check-circle" aria-hidden="true"></i>
                  </h4>
                  <span>Carpenter</span>
                </div>
                <div class="providerset-prices">
                  <h6>$50.00<span>/hr</span></h6>
                </div>
              </div>
              <div class="provider-rating">
                <div class="rating">
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star-half-stroke filled"></i><span>(228)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="providerset">
            <div class="providerset-img">
              <router-link to="/service-provider/provider-details">
                <img src="@/assets/img/provider/provider-13.jpg" alt="img" />
              </router-link>
            </div>
            <div class="providerset-content">
              <div class="providerset-price">
                <div class="providerset-name">
                  <h4>
                    <router-link to="/service-provider/provider-details">Antoinette</router-link
                    ><i class="fa fa-check-circle" aria-hidden="true"></i>
                  </h4>
                  <span>Cleaner</span>
                </div>
                <div class="providerset-prices">
                  <h6>$25.00<span>/hr</span></h6>
                </div>
              </div>
              <div class="provider-rating">
                <div class="rating">
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star-half-stroke filled"></i><span>(130)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="providerset">
            <div class="providerset-img">
              <router-link to="/service-provider/provider-details">
                <img src="@/assets/img/provider/provider-14.jpg" alt="img" />
              </router-link>
            </div>
            <div class="providerset-content">
              <div class="providerset-price">
                <div class="providerset-name">
                  <h4>
                    <router-link to="/service-provider/provider-details">Thompson</router-link
                    ><i class="fa fa-check-circle" aria-hidden="true"></i>
                  </h4>
                  <span>Mechanic</span>
                </div>
                <div class="providerset-prices">
                  <h6>$25.00<span>/hr</span></h6>
                </div>
              </div>
              <div class="provider-rating">
                <div class="rating">
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star filled me-1"></i>
                  <i class="fa-solid fa-star-half-stroke filled"></i><span>(95)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Providers Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexfeaturedservice from "@/assets/json/indexfeaturedservice.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexfeaturedservice: indexfeaturedservice,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        320: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        575: {
          itemsToShow: 1.8,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  methods: {
    toggleSelected(event) {
      const element = event.target;
      element.classList.toggle("selected");
    },
  },
};
</script>
